import GiphyApiInputModal from './toolbar/giphyApiInputModal';

const Modals = {
  GIPHY_API_INPUT: 'giphy-api-input',
};

const ModalsMap = {
  [Modals.GIPHY_API_INPUT]: GiphyApiInputModal,
};

export { Modals, ModalsMap };
